import { APICore } from '../../helpers/api/apiCore';
import * as URL from "../../helpers/api/apiEndPoint"

const api = new APICore();


function getTransactionCsv(params: any): any {
    const { type, startDate, endDate } = params?.data
    return api.get(`${URL.GET_TRANSACTION_CSV}?type=${type}&startDate=${startDate}&endDate=${endDate}`);
};

function getAccountCsv(params: any): any {
    const { startDate, endDate } = params?.data
    return api.get(`${URL.GET_ACCOUNT_CSV}?startDate=${startDate}&endDate=${endDate}`);
};
function getTraderCsv(params: any): any {
    const { startDate, endDate } = params?.data
    return api.get(`${URL.GET_TRADER_CSV}?startDate=${startDate}&endDate=${endDate}`);
};
function getUserCsv(params: any): any {
    const { startDate, endDate } = params?.data
    return api.get(`${URL.GET_USER_CSV}?startDate=${startDate}&endDate=${endDate}`);
};
function getCommodityCsv(params: any): any {
    const { startDate, endDate } = params?.data
    return api.get(`${URL.GET_COMMODITY_CSV}?startDate=${startDate}&endDate=${endDate}`);
};

export { getTransactionCsv, getAccountCsv, getTraderCsv, getUserCsv, getCommodityCsv }